export default {
  enablePickupTime: "وقت وصول العميل",
  enablePickupTimeInputHeader: "وقت وصول العميل",
  enablePickupTimeText: "تمكين العملاء من اختيار وقت الوصول عند إتمام الطلب.",
};
